import { authAxios } from "./axiosClient";
import { ProjectDescription, LogsDescriptionMonth, GetDescriptionDec, CopyDataDescription, ImportMutipleDescription, ExportDataDescription } from "../constants";

export const GetListProjectDescription = (params = {}) => {
  const url = ProjectDescription;
  return authAxios().get(url, { params });
};

export const PostListProjectDescription = (params = {}) => {
  const url = ProjectDescription;
  return authAxios().post(url, params);
};

export const GetIdProjectDescription = (params = {}) => {
  const url = ProjectDescription;
  return authAxios().get(url, { params });
};

export const PutProjectDescription = (params = {}) => {
  const url = ProjectDescription;
  return authAxios().post(url, params);
};

export const UpdateMonthDetailDescription = (params = {}) => {
  const url = ProjectDescription;
  return authAxios().post(url, params);
};

export const getLogsDescriptionMonth = (params = {}) => {
  const url = LogsDescriptionMonth;
  return authAxios().get(url, { params });
};


// Check dữ liệu năm mới đã được tạo sao với năm cũ từ tháng 12
export const getDescriptionMonthDec = (params = {}) => {
  const url = GetDescriptionDec;
  return authAxios().get(url, { params });
};


// Copy dữ liệu năm mới đã được tạo tháng 12 sang năm mới
export const copyDescriptionDes = (params = {}) => {
  const url = CopyDataDescription;
  return authAxios().get(url, { params });
};

// Import file excel 
export const ImportDataDescription = (params = {}) => {
  const url = ImportMutipleDescription;
  return authAxios().post(url, params);
};

// Export file excel
export const ExportProjectDescription = (params = {}) => {
  const url = ExportDataDescription;
  return authAxios().get(url, { params });
};